import { useState } from 'react';
import { useWorkspaceStore } from '../../../store/workspace';
import PromptSettingsPanel from './PromptSettingsPanel';
import '../../../theme/components/footer.css';

const EditorFooter = () => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const activeDocumentId = useWorkspaceStore(state => state.activeDocumentId);
  
  const togglePanel = () => setIsPanelOpen(!isPanelOpen);
  
  // 检测平台，显示正确的快捷键
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  const modKey = isMac ? '⌘' : 'Ctrl';
  
  return (
    <>
      <div 
        className="editor-content-footer"
        onClick={togglePanel}
      >
        <div className="editor-footer-content">
            <div className="footer-arrow-up">↑</div>
            <div className="footer-tip">
              按下 {modKey} + Enter 启动 AI 协作
            </div>
        </div>
      </div>
      
      {activeDocumentId && (
        <PromptSettingsPanel 
          isOpen={isPanelOpen} 
          onClose={() => setIsPanelOpen(false)}
          documentId={activeDocumentId}
        />
      )}
    </>
  );
};

export default EditorFooter; 